
import { LOT_OPTIONS } from '../CreateActivityAndPricing/ActivityItemPricing/ActivityItemPricingConsts';

export { LOT_OPTIONS };

export const mapServerLotOptionsToAppliesTo = (allLots, allTenantLots) => {
    if (allTenantLots) return LOT_OPTIONS.ALL_TENANT_LOTS;
    if (allLots) return LOT_OPTIONS.ALL_LOTS;
    return LOT_OPTIONS.SPECIFIC_LOTS;
};

export const mapAppliesToToServerLotOptions = (appliesTo) => ({
    allLots: appliesTo === LOT_OPTIONS.ALL_LOTS,
    allTenantLots: appliesTo === LOT_OPTIONS.ALL_TENANT_LOTS || appliesTo === LOT_OPTIONS.ALL_PMF_LOTS
});


export const normalizeServerRule = (rule) => {
    if (!rule) return rule;

    const normalized = { ...rule };

    // Normalize lotId to an array of valid IDs only
    if (normalized.lotId != null) {
        const normalizedLotIds = (Array.isArray(normalized.lotId)
            ? normalized.lotId
            : [normalized.lotId]
        ).filter(Boolean);

        normalized.lotId = normalizedLotIds;
    }

    if (!normalized.appliesTo) {
        const hasLotId = Array.isArray(normalized.lotId) && normalized.lotId.length > 0;

        if (hasLotId) {
            normalized.appliesTo = LOT_OPTIONS.SPECIFIC_LOTS;
        }
        else {
            normalized.appliesTo = mapServerLotOptionsToAppliesTo(
                rule.allLots || false,
                rule.allTenantLots || false
            );
        }
    }

    return normalized;
};


//Stable sort helpers for deep-equality comparison of pricing / rule arrays.

const safeId = (item) => (item.id != null ? item.id : Number.MAX_SAFE_INTEGER);

export const normalizePricing = (items = []) =>
    [...items].sort((a, b) => safeId(a) - safeId(b));

export const normalizeRules = (rules = []) =>
    [...rules].sort((a, b) => safeId(a) - safeId(b));
